const actions = {
  getUsers ({
    commit
  }) {
    this.$app.$http.get('users').then((response) => {
      commit('YOUR_MUTATION_HERE', response)
    })
  }
}

export default actions
